import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import injectSheet from 'react-jss';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';

import { getSyntaxOptions } from './EcBooleanTextSearchPopup.options';
import styles from './EcBooleanTextSearchPopup.styles';

function EcBooleanTextSearchPopup({ classes, handleOnCloseClick }) {
  const intl = useIntl();
  const syntaxOptions = getSyntaxOptions(intl);

  return (
    <div
      className={classes.booleanSyntaxPopup}
      role="dialog"
      aria-labelledby="searchOperatorTitle"
    >
      <div className={classes.booleanSyntaxHeader}>
        <div className={classes.booleanSyntaxTitle} id="searchOperatorTitle">
          <Icon icon="info" />
          {intl.formatMessage({
            id: 'EcBooleanTextSearchPopup.searchOperators',
            defaultMessage: 'Search Operators',
            description: 'Header title for search operators dialog',
          })}
        </div>
        <IconButton
          icon="x"
          text={intl.formatMessage({
            id: 'EcBooleanTextSearchPopup.closeDialogText',
            defaultMessage: 'close search operators hint dialog',
            description: 'Accessibility text for close button',
          })}
          tooltip={intl.formatMessage({
            id: 'EcBooleanTextSearchPopup.closeTooltip',
            defaultMessage: 'Close',
            description: 'Tooltip for close button',
          })}
          onClick={handleOnCloseClick}
        />
      </div>
      <div className={classes.booleanSyntaxOptionsList}>
        {syntaxOptions.map((option, index) => {
          const getLabel = () => {
            return option.examples.map((example) => {
              return `${example.text} ${example.description}`;
            });
          };
          const getTooltipContent = () => {
            return option.examples.map((example, exampleIndex) => {
              return (
                <div
                  className={classes.optionTooltipExample}
                  key={`example-${exampleIndex}`}
                >
                  <div className={classes.optionTooltipText}>
                    {intl.formatMessage(
                      {
                        id: 'EcBooleanTextSearchPopup.exampleLabel',
                        defaultMessage: 'Example: {text}',
                        description:
                          'Label for syntax example. Example: text = "sample text"',
                      },
                      { text: example.text },
                    )}
                  </div>
                  <div className={classes.optionTooltipDescription}>
                    {example.description}
                  </div>
                </div>
              );
            });
          };
          return (
            <div
              className={classes.booleanSyntaxOption}
              key={`syntax-option-${index}`}
            >
              <div className={classes.optionLabelContainer}>
                <div className={classes.optionLabel}>{option.label}</div>
              </div>
              <div className={classes.optionDescription}>
                {option.description}
              </div>
              <Icon
                icon="info"
                label={getLabel()}
                tooltip={getTooltipContent()}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

EcBooleanTextSearchPopup.propTypes = {
  classes: PropTypes.object.isRequired,
  handleOnCloseClick: PropTypes.func.isRequired,
};

export default injectSheet(styles)(EcBooleanTextSearchPopup);
